import { IVY_WORDMARK_PATH, IVY_WORDMARK_VIEWBOX } from '@/components/brand/ivy-wordmark-paths'
import { cn } from '@/lib/utils'

type IvyWordmarkProps = {
  className?: string
  height?: number
  color?: string
  'aria-hidden'?: boolean
}

export function IvyWordmark({
  className,
  height = 24,
  color = 'var(--accent-1)',
  'aria-hidden': ariaHidden,
}: IvyWordmarkProps) {
  const width = (height / IVY_WORDMARK_VIEWBOX.height) * IVY_WORDMARK_VIEWBOX.width

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${IVY_WORDMARK_VIEWBOX.width} ${IVY_WORDMARK_VIEWBOX.height}`}
      width={width}
      height={height}
      fill="none"
      className={cn('shrink-0', className)}
      role={ariaHidden ? undefined : 'img'}
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : 'Ivy'}
    >
      <path d={IVY_WORDMARK_PATH} fill={color} />
    </svg>
  )
}
